import {
  NativeStackHeaderProps,
  Stack,
  useLocalSearchParams,
} from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import BodyBaseBoldText from 'shared/components/vxl/typography/primary/body/BodyBaseBoldText';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import { navigateBack } from 'shared/helpers/backNavigation.helpers';
import theme from 'shared/styles/theme';

const TabaPayLimitInfo = () => {
  const { t: translatedText } = useTranslation('moveMoney', {
    keyPrefix: 'transferStrings',
  });
  const {
    monthlyLimitTitle,
    monthlyLimitMessage1,
    monthlyLimitMessage2,
    dailyLimitTitle,
    dailyLimitMessage1,
    dailyLimitMessage2,
    disclaimer,
  } = useLocalSearchParams<{
    monthlyLimitTitle: string;
    monthlyLimitMessage1: string;
    monthlyLimitMessage2: string;
    dailyLimitTitle: string;
    dailyLimitMessage1: string;
    dailyLimitMessage2: string;
    disclaimer?: string;
  }>();

  return (
    <>
      <Stack.Screen
        options={{
          headerShown: true,
          title: translatedText('limits'),
          headerBackVisible: true,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} primaryOnPress={navigateBack} />
          ),
        }}
      />
      <View style={styles.container}>
        <BodyBaseBoldText>{dailyLimitTitle}</BodyBaseBoldText>
        <BodyBaseText style={styles.contentPadding}>
          {dailyLimitMessage1}
        </BodyBaseText>
        <BodyBaseText> {dailyLimitMessage2}</BodyBaseText>
        <View style={styles.sectionPadding}>
          <BodyBaseBoldText>{monthlyLimitTitle}</BodyBaseBoldText>
          <BodyBaseText style={styles.contentPadding}>
            {monthlyLimitMessage1}
          </BodyBaseText>
          <BodyBaseText>{monthlyLimitMessage2}</BodyBaseText>
        </View>
        {disclaimer ? (
          <View style={styles.sectionPadding}>
            <BodyBaseText numberOfLines={0}>{disclaimer}</BodyBaseText>
          </View>
        ) : null}
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    paddingHorizontal: theme.spacing.m,
  },
  contentPadding: {
    paddingVertical: theme.spacing.s,
  },

  sectionPadding: {
    paddingTop: theme.spacing.m,
  },
});

export default TabaPayLimitInfo;
